import React from 'react';
import './Banner.css';
import bannerImage from '../../images/banner.jpg'
import { Button, Modal } from 'react-bootstrap';
import closeButton from '../../images/close.svg';

const Banner = ({ show, handleClose }) => {
    return (
        <Modal show={show}
            onHide={handleClose}
            centered
            className='banner-modal'
            size="lg"
        >
            <Modal.Header >
                <img src={closeButton} onClick={handleClose} />
            </Modal.Header>
            <Modal.Body>
                <img src={bannerImage} />
            </Modal.Body>
            <Modal.Footer>
                <a href='https://landing.zargroup.ir/?utm_source=chocotripsofficial&utm_medium=PopUp&utm_campaign=BigSaleCampaign' target='_blank'>
                    <Button variant="secondary" onClick={handleClose}>
                        اطلاعات بیشتر
                    </Button>
                </a>
            </Modal.Footer>
        </Modal>
    )
}

export default Banner